<template>
    <layout-machine-introduction :unsaved-puri-count="unsavedPuriCount"
                                 :latest-image-id="latestImageId"
                                 :is-searchable="isSearchable"
                                 :machine-id="machineId"
                                 :section-title-list="sectionTitleList"
                                 :has-top-border-anchor-link="false"
                                 :has-title-anchor-link="false"
                                 :has-border-anchor-link="false"
                                 :has-movie-title="false"
                                 youtube-url="https://youtube.com/shorts/hw3qx-6VUzk"
    >

        <template v-slot:feature-summary>
            <img :src="buildImgUrl('img_feature_summary.png')" alt="わたウサの基本情報">
        </template>
        <template v-slot:content-1>
            <div class="cont-01">
                <img class="img-01" :src="buildImgUrl('img_contents01_01.png')" alt="ビビかわ盛れ">
                <div class="cont-01-bk">
                    <img class="img-02" :src="buildImgUrl('img_contents01_02.png')"
                         alt="くっきりだけど強すぎない可愛い盛れ感♥">
                </div>
            </div>
        </template>
        <template v-slot:content-2>
            <div class="cont-02">
                <div class="cont-02-bk">
                    <img class="img-01" :src="buildImgUrl('img_contents02_01.png')"
                         alt="その日の予定や目的に合わせて撮影枚数〜落書きスキップを選択できるよ">
                    <img class="img-02" :src="buildImgUrl('img_contents02_02.png')" alt="撮影枚数のメリット">
                    <img class="img-03" :src="buildImgUrl('img_contents02_03.png')" alt="ポーズの選択のメリット">
                    <img class="img-04" :src="buildImgUrl('img_contents02_04.png')" alt="落書きするを選んだら">
                    <img class="img-05" :src="buildImgUrl('img_contents02_05.png')" alt="落書きしないを選んだら">
                </div>
            </div>
        </template>
        <template v-slot:content-3>
            <div class="cont-03">
                <img :src="buildImgUrl('img_contents03_bk.png')">
                <img class="gif-01" :src="buildImgUrl('gif_1.gif')" alt="ノーマル">
                <img class="gif-02" :src="buildImgUrl('gif_2.gif')" alt="グラデーション">
                <img class="gif-03" :src="buildImgUrl('gif_3.gif')" alt="ハート">
            </div>
        </template>
        <template v-slot:content-4>
            <div class="cont-04">
                <div class="cont-04-bk">
                    <img class="img-01" :src="buildImgUrl('img_contents04_01.png')" alt="シール編集するを選んだら">
                    <img class="img-02" :src="buildImgUrl('img_contents04_02.png')" alt="シールを編集しないを選んだら">
                </div>
            </div>
        </template>
    </layout-machine-introduction>
</template>

<script>
import LayoutMachineIntroduction from "../../templates/LayoutMachineIntroduction.vue";
import * as urlUtil from "../../../util/UrlUtil";
import {mapActions} from "vuex";
export default {
    name: "MachineWatausa1",
    components: {LayoutMachineIntroduction},
    props: {
        /**
         * Headerコンポーネント用
         * 未保存プリ数
         */
        unsavedPuriCount: {
            type: String,
            required: true
        },
        /**
         * Headerコンポーネント用
         * 最新プリID
         */
        latestImageId: {
            type: String,
            required: true
        },
        /**
         * 当該機種が「遊べるお店を探す」によって検索可能であるかどうかを判定する.
         * toolboxから取得
         * 「遊べるお店を探す」表示判定
         */
        isSearchable: {
            type: Boolean,
            required: true
        },
    },
    computed: {
        machineId() {
            return 156;
        },
        sectionTitleList() {
            return [
                '01 くっきり可愛い ビビかわ盛れ',
                '02 自分好みにゲームに変えられる カスタムメニュー',
                '03 ビビかわ漏れが映える カラー背景',
                '04 自分だけの完全オリジナルシールが作れる シール編集',
            ];
        }
    },
    mounted() {
        /**
         * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
         * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
         */
        this.getAccountStatus()
    },
    methods: {
        ...mapActions({
            getAccountStatus: 'AccountStoreV2/getAccountStatus'
        }),
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.machineIntroductionImageUrl(String(this.machineId), imgName)
        },
        /**
         * cssのurl関数に動的な文字列を与えようとすると、上手くcssの関数が呼び出せなかったので、
         * url関数の呼び出し部分の含めた文字列をv-bindで組み立てからstyleで使えるようにしている
         */
        buildStyleImgUrl(imageName) {
            const imgUrl = this.buildImgUrl(imageName)
            return `url(${imgUrl})`;
        }
    }
}
</script>

<style scoped lang="scss">
@use "sass:math";
@use "../../../../scss/v2/base/variables";
$deviceWidth: 750px;
:deep(*) {
    .c-machine-introduction {
        &-top {
            .btn-puri-list {
                position: absolute;
                width: math.percentage(math.div(188px, $deviceWidth));
                top: math.percentage(math.div(242px, $deviceWidth));
                right: math.percentage(math.div(20px, $deviceWidth));
            }
            .btn-shop-list {
                position: absolute;
                top: math.percentage(math.div(330px, $deviceWidth));
                left: 0;
                width: 100%;
                &-link {
                    width: math.percentage(math.div(530px, $deviceWidth));
                }
            }
            .list-anchor-link-feature-summary {
                background-image: v-bind("buildStyleImgUrl('link_bk.png')");
                background-repeat: no-repeat;
                background-size: 100%;
            }
            .list-anchor-link {
                padding: (variables.$grid-base) 0 0 0;
                .img-link {
                    width: math.percentage(math.div(594px, $deviceWidth));
                }
                .img-line {
                    width: math.percentage(math.div(594px, $deviceWidth));
                    display: block;
                    margin: auto;
                }
            }
            .feature-summary {
                width: math.percentage(math.div(594px, $deviceWidth));
                padding: 5px 0 (variables.$grid-base+13) 0;
                margin: auto;
            }
        }
        &-contents {
            .accordion-inner {
                .img-01, .img-02, .img-03, .img-04, .img-05, .img-06, .img-07, {
                    display: block;
                }
                .cont-01 {
                    &-bk {
                        background: v-bind("buildStyleImgUrl('img_contents01_02_bk.png')");
                        background-size: cover;
                    }
                }
                .cont-02 {
                    &-bk {
                        background: v-bind("buildStyleImgUrl('img_contents02_bk.png')");
                        background-size: cover;
                    }
                }
                .cont-04 {
                    &-bk {
                        background: v-bind("buildStyleImgUrl('img_contents04_bk.png')");
                        background-size: cover;
                    }
                }
                .cont-03 {
                    position: relative;
                    .gif-01 {
                        position: absolute;
                        top: 38%;
                        left: 3%;
                        width: math.percentage(math.div(215px, $deviceWidth));
                    }
                    .gif-02 {
                        position: absolute;
                        top: 38%;
                        right: 36%;
                        width: math.percentage(math.div(215px, $deviceWidth));
                    }
                    .gif-03 {
                        position: absolute;
                        top: 38%;
                        right: 3%;
                        width: math.percentage(math.div(215px, $deviceWidth));
                    }
                }
            }
        }
        &-movie {
            padding: variables.$grid-consistent * 17 0 variables.$grid-consistent * 21;
            background-image: v-bind("buildStyleImgUrl('movie_back.png')");
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            &-thumb {
                width: math.percentage(math.div(650px, $deviceWidth));
                margin: auto;
            }
        }
    }
}
</style>
